var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { space, display, position, width, minWidth, height, maxHeight, themeGet, } from 'styled-system';
import { getTrackerProps } from '../../common/tracking/getTrackerProps';
import { modifiers } from '../../common/theme/helper';
import { Link } from '../../common/components/Link';
import { ItemPropType, } from '../../common/prop-types/NavigationItem';
import KeepFocusWithFirstTouch from '../../common/components/KeepFocusWithFirstTouch';
import NavigationDropdown from './NavigationDropdown';
export var NavigationLine = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  justify-content: ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  justify-content: ", ";\n"])), position, width, display, function (props) { return (props.primary ? 'space-between' : 'center'); });
NavigationLine.defaultProps = {
    display: 'flex',
    position: 'relative',
    width: '100%',
};
export var NavigationItem = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n\n  align-items: center;\n\n  &:first-of-type {\n    padding-left: 0;\n  }\n\n  &:last-of-type {\n    padding-right: 0;\n  }\n"], ["\n  ", ";\n  ", ";\n\n  align-items: center;\n\n  &:first-of-type {\n    padding-left: 0;\n  }\n\n  &:last-of-type {\n    padding-right: 0;\n  }\n"])), space, display);
NavigationItem.defaultProps = {
    px: 2,
    display: 'flex',
};
export var NavigationLink = styled(Link)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  text-decoration: none !important;\n\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  text-decoration: none !important;\n\n  ",
    ";\n"])), position, display, space, modifiers, function (props) {
    var focused = props.focused, noPadding = props.noPadding, primary = props.primary;
    var px = noPadding ? 0 : primary ? '12px' : themeGet('space.2')(props);
    return __assign({ paddingTop: px, paddingBottom: px, fontWeight: primary ? 'bold' : 'normal', color: focused && themeGet('colors.brand.normal')(props) }, (focused && {
        '&::after': {
            content: '',
            position: 'absolute',
            zIndex: 1000,
            bottom: noPadding ? '-2px' : '-3px',
            left: '50%',
            width: '12px',
            height: '12px',
            backgroundColor: themeGet('colors.gray.0')(props),
            boxShadow: "inset 1px 1px 0 " + themeGet('colors.gray.5')(props),
            transform: 'translateX(-50%) rotate(45deg)',
        },
    }));
});
NavigationLink.defaultProps = __assign(__assign({}, Link.defaultProps), { position: 'relative', display: 'block', fontSize: 4, lineHeight: 2 });
export var SecondaryNavigation = function (_a) {
    var items = _a.items;
    return (React.createElement(NavigationLine, null, items.map(function (item, index) { return (React.createElement(NavigationItem, { "data-testid": "secondary-item-" + index, key: item.name },
        React.createElement(NavigationLink, __assign({}, getTrackerProps({
            'data-testid': 'item-label',
            href: item.href,
            image: item.image,
            modifiers: item.modifiers,
        }, {
            event: 'navigation',
            eventData: __assign(__assign({}, (item.image && { label: item.name })), { placement: 'secondaryNavigation', currentNavLevel: null, destinationNavLevel: 1, navPath: [item.name], listIndex: index, listLength: items.length }),
        })), item.name))); })));
};
SecondaryNavigation.propTypes = {
    items: PropTypes.arrayOf(ItemPropType),
};
var PrimaryItemImage = styled.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), display, width, minWidth, height, maxHeight);
PrimaryItemImage.defaultProps = {
    display: 'block',
    width: 'auto',
    minWidth: '1px',
    height: '47px',
    maxHeight: '47px',
};
export var PrimaryNavigation = function (_a) {
    var items = _a.items;
    return (React.createElement(NavigationLine, { primary: true }, items.map(function (item, index) {
        var isNested = !!(item.children && item.children.length > 0);
        return (React.createElement(NavigationItem, { key: item.name, active: isNested, "data-testid": "primary-item-" + index, as: KeepFocusWithFirstTouch }, function (_a) {
            var focused = _a.focused;
            return (React.createElement(Fragment, null,
                React.createElement(NavigationLink, __assign({}, getTrackerProps({
                    'data-testid': 'item-label',
                    href: item.href,
                    primary: true,
                    noPadding: !!item.image,
                    modifiers: item.modifiers,
                    focused: focused,
                }, {
                    event: 'navigation',
                    eventData: __assign(__assign({}, (item.image && { label: item.name })), { placement: 'primaryNavigation', currentNavLevel: null, destinationNavLevel: 1, navPath: [item.name], listIndex: index, listLength: items.length }),
                })), item.image ? (React.createElement(PrimaryItemImage, { src: item.image, alt: item.name, "data-testid": "item-image" })) : (item.name)),
                isNested && (React.createElement(NavigationDropdown, { level1Name: item.name, items: item.children, focused: focused }))));
        }));
    })));
};
PrimaryNavigation.propTypes = {
    items: PropTypes.arrayOf(ItemPropType),
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
